export const SITE = {
  name: "Avv. Manfredi Bruno",
  studio: "Studio Legale Avv. Manfredi Bruno",
  tagline: "Avvocato del lavoro e della previdenza a Palermo",
  address: "Via Salvatore Meccio n. 22, 90141 Palermo (PA)",
  addressShort: "Via Salvatore Meccio 22, Palermo",
  phone: "091 322514",
  phoneHref: "tel:+39091322514",
  email: "info@avvmanfredibruno.it",
  emailHref: "mailto:info@avvmanfredibruno.it",
  googleProfile: "https://www.google.com/search?sca_esv=4511509f43aa6d52&hl=it-IT&sxsrf=APpeQntxHCP2cf9ZK4O8G7w1IkkiMg8tgw:1788107205943&q=recensioni+di+avvocato+manfredi+bruno+palermo&uds=AJ5uw1_a2D0D09lxm8gpKKOTUn4rbhbcdckkJHb4y7Ov1MVmz5KkTmxpyrkWAZOow-sDvONhBYEXrQPDuYgjX7H4X-djhAmE0OCbP8DEY4tfEpO-vi7auevaYLhFGtcGeYg2Q4V_82umUdSLHDaPEBEaIttZIsM_Um7M9tHkDAN8P7fp9jvPR1XNlT4DJ5FbAGlL0Eztc6TwgnDNnBkAw4wV6e2quPCfEw&si=APenkKm7iecQ4G6P-TsbSMFKIQtv3EFIqRAFw-i8uEbk55Z-_y9kALp04rVwAT5QthLpvPcDH3glmGdOQl5VIATTmZ0tEyMG4xg0w118S-oRZ8S0-qJwJZGbsSGFKm32-fvaywVv6qxizs_KqzJP1OQI7IMzt3v0ntwlNgJRunrHYKEQnDIi_Pw%3D&sa=X&ved=2ahUKEwj4_dG24siWAxXo1gIHHUTwOWQQxKsJKAB6BAgMEAE&ictx=1&biw=1536&bih=730&dpr=1.25",
  mapsEmbed:
    "https://www.google.com/maps?q=Via+Salvatore+Meccio+22,+90141+Palermo,+Italia&output=embed",
  mapsLink:
    "https://www.google.com/maps/search/?api=1&query=Via+Salvatore+Meccio+22+90141+Palermo",
};

export const NAV_MAIN = [
  { name: "Diritto del Lavoro", path: "/diritto-del-lavoro" },
  { name: "Diritto Previdenziale", path: "/diritto-previdenziale" },
  { name: "Chi Sono", path: "/chi-sono" },
  { name: "Recensioni", path: "/recensioni" },
  { name: "Approfondimenti", path: "/approfondimenti" },
  { name: "Contatti", path: "/contatti" },
];

export const NAV_AREE = [
  { name: "Diritto del lavoro", path: "/diritto-del-lavoro" },
  { name: "Licenziamento", path: "/licenziamento" },
  { name: "Recupero crediti e TFR", path: "/recupero-crediti-tfr" },
  { name: "Diritto previdenziale", path: "/diritto-previdenziale" },
  { name: "INPS e ricorsi", path: "/inps-ricorsi" },
  { name: "Indebiti e restituzioni INPS", path: "/indebiti-inps-palermo" },
  { name: "Invalidità civile", path: "/invalidita-civile" },
  { name: "Ricorso invalidità e accompagnamento", path: "/ricorso-inps-invalidita-accompagnamento-palermo" },
  { name: "Pensioni", path: "/pensioni" },
];

export const CONTACT_TOPICS = [
  "Diritto del lavoro",
  "Licenziamento",
  "Recupero crediti da lavoro e TFR",
  "Diritto previdenziale / INPS",
  "Indebiti INPS / richiesta di restituzione",
  "Invalidità civile",
  "Pensioni",
  "Altro",
];

export const REVIEWS = [];
